import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { numberFormatter } from "@common/helpers/number";
import { useMemo } from "react";
import { pluralize } from "@common/helpers/string";
import { useBulkActions } from "../useBulkActions";

interface RemoveCustomerConfirmationModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => Promise<void>;
}

export const RemoveCustomerConfirmationModal: React.FC<
    RemoveCustomerConfirmationModalProps
> = ({ show, onHide, onConfirm }) => {
    const bulkActions = useBulkActions();

    const transactionsWithCustomerId = useMemo(
        () =>
            bulkActions.selectedArray.filter(
                (transaction) => transaction.customerId,
            ),
        [bulkActions.selectedArray],
    );

    const selectedCount = bulkActions.selectedCount;

    const haveOrHas = transactionsWithCustomerId.length > 1 ? "have" : "has";
    const themOrIt = transactionsWithCustomerId.length > 1 ? "them" : "it";
    const assignmentPlural = pluralize(
        "assignment",
        transactionsWithCustomerId.length,
    );
    const title = `Remove billable customer for ${numberFormatter.format(transactionsWithCustomerId.length)} ${pluralize("transaction", transactionsWithCustomerId.length)}`;

    const allSelectedText =
        selectedCount === 1
            ? "the selected transaction"
            : "all selected transactions";

    const question =
        transactionsWithCustomerId.length === selectedCount
            ? `Are you sure you want to remove the billable customer ${assignmentPlural} for ${allSelectedText}?`
            : `${numberFormatter.format(transactionsWithCustomerId.length)} of ${numberFormatter.format(selectedCount)} selected transactions ${haveOrHas} a billable customer assigned. Do you want to remove ${themOrIt}?`;

    return (
        <ConfirmationModal
            show={show}
            onHide={onHide}
            onReject={onHide}
            onConfirm={onConfirm}
            title={title}
            question={question}
            yes="Remove"
            yesBtnVariant="primary"
        />
    );
};
